import * as Masks from './styles'

export default Masks
